import { HandThumbUpIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedDeliverableMatchApprovedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface DeliverableMatchApprovedEventProps {
  event: DiscriminatedDeliverableMatchApprovedEvent;
}

export const DeliverableMatchApprovedEvent: React.FC<
  DeliverableMatchApprovedEventProps
> = ({ event }) => {
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-green-100">
          <HandThumbUpIcon className="h-4 w-4 text-green-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityDescription>
        <div className="font-medium text-gray-900 text-sm">Match approved</div>
      </ActivityDescription>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Deliverable Match Approved"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
